import * as React from 'react';
import EventStepper from '../../../../../components/EventStepper';
import { fm } from 'Components/FormatMessage';
import InputHandler from '../../../../../components/InputHandler';
import { StepperHeaderFormInputPair, StepperHeaderValuePair } from 'Components/EventStepper/components';
import { formatPartialDate } from 'Utility/date';

const AdverseEffects = ({ formData }: IOwnProps): React.JSX.Element => {
  return (
    <EventStepper
      name="adverseEffects"
      formData={formData}
      stepLabelText={(d: IRTMSAdverseEffect): string => formatPartialDate(d.date)}
      stepContent={(d: IRTMSAdverseEffect): React.JSX.Element => (
        <React.Fragment>
          {['adverseEffects', 'additionalInformation'].map((key, index) => {
            const value = d[key as keyof IRTMSAdverseEffect];
            return (
              <StepperHeaderValuePair
                key={`${key}${index}`}
                header={fm(`rtms.${key}`)}
                value={
                  value && (Array.isArray(value) ? value.length > 0 : true)
                    ? key === 'adverseEffects' && Array.isArray(value)
                      ? value.map(v => <div key={v}>{fm(`rtms.opts.adverseEffects.${v}`)}</div>)
                      : value
                    : '-'
                }
              />
            );
          })}
        </React.Fragment>
      )}
      addNewTextHeader="rtms.adverseEffects"
      addNewTextButton="rtms.newAdverseEffect"
      previousEventsTextHeader="rtms.previousAdverseEffects"
      editingElements={(index: number, onChange: IFormData['onChange']): React.JSX.Element => (
        <React.Fragment>
          <StepperHeaderFormInputPair
            header={fm('general.date')}
            input={
              <InputHandler
                type="PartialDate"
                editing={true}
                name="date"
                formData={{
                  onChange,
                  document: { date: formData.document.adverseEffects?.[index]?.date ?? '' },
                }}
                dateDefault="now"
                isNotCancellable={true}
                dateHook={{ dateHookFloor: formData.document.date ?? undefined }}
              />
            }
          />
          <StepperHeaderFormInputPair
            header={fm('rtms.adverseEffects')}
            input={
              <InputHandler
                type="Checkbox"
                editing={true}
                name="adverseEffects"
                formData={{
                  onChange,
                  document: { adverseEffects: formData.document.adverseEffects?.[index]?.adverseEffects ?? '' },
                }}
                options={[
                  'relapse',
                  'headache',
                  'fatigue',
                  'nausea',
                  'skinIrritation',
                  'mentalConfusion',
                  'memoryProblem',
                  'sensoryDistortion',
                  'epilepticSeizure',
                  'other',
                ]}
                optionFormatter={(name: string | number): React.JSX.Element => fm(`rtms.opts.adverseEffects.${name}`)}
              />
            }
          />
          <StepperHeaderFormInputPair
            header={fm('rtms.additionalInformation')}
            input={
              <InputHandler
                type="TextArea"
                editing={true}
                name="additionalInformation"
                formData={{
                  onChange,
                  document: {
                    additionalInformation: formData.document.adverseEffects?.[index]?.additionalInformation ?? '',
                  },
                }}
                placeholder="rtms.additionalInformationAdverseEffects"
              />
            }
          />
        </React.Fragment>
      )}
    />
  );
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'rtms'>>;
}

export default AdverseEffects;
